export const exportHeaders = [
    {
        label: "Loyalty Id",
        key: "loyalty_id"
    },
    {
        label: "Billto",
        key: "customer_billto_account_number",
    },
    {
        label: "Points Balance",
        key: "points_balance",
    },
    {
        label: "Consecutive Negative (days)",
        key: "negative_count",
    },
    {
        label: "Day 1 Email",
        key: "first_day",
    },
    {
        label: "60th Day Email",
        key: "sixity_day",
    },
    {
        label: "90th Day Email",
        key: "ninity_day",
    },
   ]
   export const exportHeadersCa = [
    {
        label: "Loyalty Id",
        key: "loyalty_id"
    },
    {
        label: "Billto",
        key: "customer_billto_account_number",
    },
    {
        label: "Points Balance",
        key: "points_balance",
    },
    {
        label: "Consecutive Negative (days)",
        key: "negative_count",
    }
   ]